import Vue from 'vue'
import EntityBasicInfo from '../components/EntityBasicInfo'
import EntityEvents from '../components/EntityEvents'
import ESGIndustryRatingBarChart from '../../esg/components/ESGIndustryRatingBarChart'
import ESGRatingLineChart from '../../esg/components/ESGRatingLineChart'
import TitleLabel from '../components/TitleLabel'
import EntityTitle from '../components/EntityTitle'
import EntityHomeSC from '../components/EntityHomeSC'
import EntityHomeAreaMap from '../components/EntityHomeAreaMap'
import EntityScInflu from '../components/EntityScInflu'
import EntityIndustryChain from '../components/EntityIndustryChain'
import httpManager from '../../util/common'
import {entityOaid, reportYear} from '../../util/util'
Vue.config.productionTip = false

let vm = {
  delimiters: ['{', '}'],
  name: 'entity-home',
  data () {
    return {
      oaid: null,
      gics: null,
      entity_info: {},
      entity_basic_info_origin: [],
      entity_basic_headers: {
        'esdate': this.$t('company_home.incorporation_date'),
        'incorporated_country': this.$t('company_home.incorporated'),
        'website': this.$t('company_home.website'),
        'dom_country': this.$t('company_home.domiciled'),
        'industryconame': this.$t('company_home.industry_classify'),
        'gics': this.$t('company_home.industry')
      },
      esg_label_list: [],
      industryCode: null
    }
  },
  computed: {
    entity_basic_info () {
      let self = this;
      let result = [];
      ['esdate', 'incorporated_country', 'website', 'dom_country', 'industryconame'].forEach(function (key, i) {
        if ((key === 'incorporated_country') || (key === 'dom_country')) {
          result.push({'key': self.entity_basic_headers[key], 'val': self.$t('country.' + self.entity_basic_info_origin[key])})
        } else {
          result.push({'key': self.entity_basic_headers[key], 'val': self.entity_basic_info_origin[key]})
        }
      })
      return result
    },
    esg_label_headers() {
      return  {
        'sub_industry': this.$t('company_home.gics'),
        'report_date': this.$t('company_home.report_date'),
        'esg_rating': this.$t('company_home.esg_rating'),
        'entity_num': this.$t('company_home.rank_of_peers')
      }
    }
  },
  watch: {
    esg_label_headers: {
      handler() {
        this.esg_label_list.forEach(item => item.label = this.esg_label_headers[item.key])
        this.esg_label_list[0].val = this.gics[this.industryCode][this.$i18n.locale]?this.gics[this.industryCode][this.$i18n.locale]:''
      },
      deep: true
    }
  },
  methods: {
    changeOaid () {
      let id = this.$route.params.oaid
      let self = this
      entityOaid.oaid(id).then(result => {
        self.oaid =result
        self.getLatestInfo(self.oaid)
        self.getEntityBasicInfo(self.oaid)
      })
    },
    getGics(){
      let self = this
      reportYear.gics().then(result => {
        self.gics =result
        this.changeOaid()
      })
    },
    getLatestInfo (oaid) {
      let self = this
      let params = new Map()
      params.set('oaid', oaid)
      httpManager('esg_latest_label', params)
        .then(response => {
          self.esg_label_list = [];
          ['sub_industry', 'report_date', 'esg_rating', 'entity_num'].forEach(function (key, i) {
            let label = self.esg_label_headers[key]?self.esg_label_headers[key]:''
            let value = ''
            let val_1 = ''
            let val_2 = ''
            let attr = response.data.data&&response.data.data[key]?response.data.data[key]:''
            if(attr) {
              if(self.gics[attr]){
                val_1 = self.gics[attr][self.$i18n.locale]?self.gics[attr][self.$i18n.locale]:''
              }
              val_2 = attr
              value = attr in self.gics?val_1:val_2
              // 若公司数量在gics中对应有行业编号会导致value改变
              if(i===3){
                value=attr
              }
              // 公司数量改排名
              // if (key === 'entity_num') {
              //   value = `${response.data.data&&response.data.data.rank?response.data.data.rank:''}/${attr}`
              // }
            }
            self.esg_label_list.push({'label': label, 'key': key, 'val': value})
          })
          self.industryCode = response.data.data['sub_industry']
        })
        .catch(error => {
          console.log(error)
        })
    },
    getEntityBasicInfo (oaid) {
      let self = this
      let params = new Map()
      params.set('oaid', oaid)
      httpManager('entity_basic_info', params)
        .then(response => {
          self.entity_info = {
            entname: response.data.data['entname'],
            entname_en: response.data.data['entname_en'],
            ticker: response.data.data['ticker'],
            bond: response.data.data['bond']
          }
          self.entity_basic_info_origin = response.data.data
        })
        .catch(error => {
          console.log(error)
        })
    }
  },
  mounted () {
    this.getGics()
  },
  components: {
    EntityBasicInfo, EntityEvents, ESGIndustryRatingBarChart, ESGRatingLineChart, TitleLabel, EntityTitle, EntityHomeSC,
    EntityHomeAreaMap, EntityScInflu, EntityIndustryChain
  }
}

export default vm



// WEBPACK FOOTER //
// ./src/entity/js/entity_home.js